<template>
  <form-caution-driver-list :is-confirmed-page="false" />
</template>
<script>
import FormCautionDriverList from '@/components/FormComponents/CautionDriverList'
export default {
  components: {
    FormCautionDriverList,
  },
}
</script>
